module.exports = __webpack_public_path__ + "static/img/pic2.0d3889d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic2.png
// module id = yUTe
// module chunks = 20